export const getInventory = async (lineItems) => {
  if (!lineItems || lineItems.length < 1) {
    return { inventoryIssues: false, results: [] }
  }
  const variants = lineItems.map(li => ({
    id: li.variant?.id || li.id,
    quantity: li.quantity
  }))
  const response = await fetch(
    `/api/product/inventory`,
    {
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify({
        variants
      })
    }
  )
  const inventory = await response.json()
  return inventory
}